import { useMemo } from 'react'
import { TokenListItem } from 'types/entities'

import { fromWei } from 'utils/crypto'
import { formatPrice } from 'utils/format'

import { Divider, TokenElement, TokenRowElem } from './Style'

type Props = TokenListItem & {
  onSetToken: (token: TokenListItem) => void
}

export function TokenRow({ onSetToken, ...token }: Props) {
  const handleClick = () => {
    onSetToken(token)
  }

  const noTokenInfo = useMemo(() => !token?.symbol && !token?.name, [token])

  const balanceToDisplay = useMemo(() => {
    const _balance = fromWei(token.balance, token.decimals)
    return formatPrice(_balance, 6)
  }, [token.balance, token.decimals])

  return (
    <TokenRowElem onClick={handleClick}>
      {noTokenInfo ? (
        <>
          <TokenElement type='symbol'>{token.address}</TokenElement>
          <Divider>==&gt;</Divider>
          <TokenElement type='balance'>{balanceToDisplay}</TokenElement>
        </>
      ) : (
        <>
          <TokenElement type='symbol'>{token.symbol}</TokenElement>
          <Divider>==&gt;</Divider>
          <TokenElement type='balance'>{balanceToDisplay}</TokenElement>
          <Divider>==&gt;</Divider>
          <TokenElement type='name'>{token.name}</TokenElement>
        </>
      )}
    </TokenRowElem>
  )
}
